import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "poster-share-box"
};
const _hoisted_2 = {
  class: "poster-share",
  id: "poster-share"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "poster-share-title"
};
const _hoisted_5 = {
  class: "share-asin-box"
};
const _hoisted_6 = {
  class: "share-asin-title"
};
const _hoisted_7 = {
  class: "share-asin-info"
};
const _hoisted_8 = {
  class: "share-asin-price"
};
const _hoisted_9 = {
  class: "share-asin-price-unit"
};
const _hoisted_10 = {
  class: "share-asin-price-integer"
};
const _hoisted_11 = {
  class: "share-asin-price-decimal"
};
const _hoisted_12 = {
  class: "share-asin-info-country"
};
import { ref, onMounted, reactive } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import ShareAsinImg1 from '@/components/shareApp/components/shareAsin/ShareAsinImg1.vue';
import ShareAsinImg2 from '@/components/shareApp/components/shareAsin/ShareAsinImg2.vue';
import ShareAsinImg3 from '@/components/shareApp/components/shareAsin/ShareAsinImg3.vue';
import ShareAsinImg4 from '@/components/shareApp/components/shareAsin/ShareAsinImg4.vue';
import ShareAsinImg5 from '@/components/shareApp/components/shareAsin/ShareAsinImg5.vue';
import ShareAsinImg6 from '@/components/shareApp/components/shareAsin/ShareAsinImg6.vue';
import { Bridge } from '@/utils/bridge';
import constants from '@/constants';
import { getAppConfig } from '@/utils/common';
export default {
  __name: 'SharePoster',
  props: ['shareConfiguration'],
  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();
    const {
      IMAGE_URL,
      APP_PAGE_CONFIG_PAGES_ENUM
    } = constants;
    const canvasRef = ref(null);
    const store = useStore();
    const posterBottomImgUrl = ref('');
    const posterContent = ref('');
    // There are six different display forms for shared posters
    const componentAsin = [ShareAsinImg1, ShareAsinImg2, ShareAsinImg3, ShareAsinImg4, ShareAsinImg5, ShareAsinImg6];
    const qrCode = ref('');
    const userName = ref('');
    const getUserInfo = async () => {
      Bridge.callFn('getCurrentUserInfo', null, infor => {
        const {
          name
        } = infor;
        userName.value = name || '';
      });
    };
    const HLOGO_IMAGE_LINK = ref(`${IMAGE_URL}assets/image/hLogo.png`);
    // todo This needs to be provided by the API.
    const priceData = reactive({
      integer: 0,
      decimal: 0
    });
    const getSettingPageConfig = async () => {
      try {
        const res = await getAppConfig(APP_PAGE_CONFIG_PAGES_ENUM.SETTING_PAGE);
        posterBottomImgUrl.value = res.posterUnderlay.imgUrls[0];
        posterContent.value = res.posterUnderlay.content.q || t('modules.share.RECOMMEND_EXCELLENT_PRODUCTS_TO_YOU');
      } catch (error) {
        console.error('func getSettingPageConfig catch error', error);
      }
    };
    const convertImgUrlToBase64Format = (el, url, outputFormat = '') => {
      return new Promise(resolve => {
        const canvas = el;
        setTimeout(() => {
          const ctx = canvas.getContext('2d');
          const img = new Image();
          img.crossOrigin = 'Anonymous';
          img.src = url;
          img.onload = function () {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            const dataURL = canvas.toDataURL(outputFormat || 'image/jpg');
            resolve(dataURL);
          };
        }, 300);
      });
    };
    const getQRCode = async () => {
      var _props$shareConfigura;
      const centerImageBase64 = await convertImgUrlToBase64Format(canvasRef.value, `${IMAGE_URL}assets/image/icon-app-logo.png`, 'image/png');
      const {
        imageBase64
      } = await Bridge.callFnVal('generateQRCodeImage', {
        content: (_props$shareConfigura = props.shareConfiguration) === null || _props$shareConfigura === void 0 ? void 0 : _props$shareConfigura.shareUrl,
        centerImageBase64
      });
      qrCode.value = imageBase64;
    };
    onMounted(async () => {
      var _props$shareConfigura2, _props$shareConfigura3, _props$shareConfigura4, _priceAmount$split$, _priceAmount$split$2;
      const priceAmount = (_props$shareConfigura2 = props.shareConfiguration) === null || _props$shareConfigura2 === void 0 ? void 0 : (_props$shareConfigura3 = _props$shareConfigura2.asinInfo) === null || _props$shareConfigura3 === void 0 ? void 0 : (_props$shareConfigura4 = _props$shareConfigura3.ourPrice) === null || _props$shareConfigura4 === void 0 ? void 0 : _props$shareConfigura4.amount.toString();
      priceData.integer = (_priceAmount$split$ = priceAmount === null || priceAmount === void 0 ? void 0 : priceAmount.split('.')[0]) !== null && _priceAmount$split$ !== void 0 ? _priceAmount$split$ : 0;
      priceData.decimal = (_priceAmount$split$2 = priceAmount === null || priceAmount === void 0 ? void 0 : priceAmount.split('.')[1]) !== null && _priceAmount$split$2 !== void 0 ? _priceAmount$split$2 : 0;
      await getSettingPageConfig();
      await getQRCode();
      await getUserInfo();
    });
    return (_ctx, _cache) => {
      const _component_van_divider = _resolveComponent("van-divider");
      const _component_asin_tag = _resolveComponent("asin-tag");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("canvas", {
        ref_key: "canvasRef",
        ref: canvasRef,
        style: {
          "display": "none"
        }
      }, null, 512), _createElementVNode("img", {
        class: "icon-app",
        src: HLOGO_IMAGE_LINK.value,
        alt: ""
      }, null, 8, _hoisted_3), _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('modules.share.AMAZON_OVERSEAS_PURCHASING_USERS') + userName.value), 1), _createVNode(_component_van_divider, {
        class: "recommend-title-box"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(posterContent.value), 1)]),
        _: 1
      }), (_openBlock(), _createBlock(_resolveDynamicComponent(componentAsin[_unref(store).getters['share/picNumSeclected']]))), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(__props.shareConfiguration.asinInfo.title), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('common.currencyUnit')), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(priceData.integer), 1), _createElementVNode("span", _hoisted_11, "." + _toDisplayString(priceData.decimal), 1)]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_asin_tag, {
        type: __props.shareConfiguration.asinInfo.merchant_badge
      }, null, 8, ["type"])])])]), _createElementVNode("div", {
        class: "poster-bottom",
        style: _normalizeStyle({
          background: `url(${posterBottomImgUrl.value})`,
          backgroundSize: '100% 100%'
        })
      }, [_createElementVNode("div", {
        class: "card-box",
        style: _normalizeStyle({
          backgroundImage: `url(${qrCode.value})`,
          backgroundSize: '100% 100%'
        })
      }, null, 4)], 4)])]);
    };
  }
};